export class PricingTier {
    pricingTierId: number;
    raffleId: number;
    tierName: string;
    ticketPrefix: string;
    quantity: number;
    price: number;
    ticketQuantity: number;
    startNumber: number;
    lastModified: string;
    lastModifiedBy: number;
    available: number;
    isSoldOut: boolean;

    // added in guest, i.e not pulled down
    qtyInCart: number = 0;
    
    public constructor(init?: Partial<PricingTier>) {
        Object.assign(this, init);
    }
}